import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=5d033054&scoped=true"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"
import style0 from "./Balance.vue?vue&type=style&index=0&id=5d033054&prod&lang=scss"
import style1 from "./Balance.vue?vue&type=style&index=1&id=5d033054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d033054",
  null
  
)

export default component.exports